import { render } from "./Video.vue?vue&type=template&id=1157cc50&scoped=true"
const script = {}

import "./Video.vue?vue&type=style&index=0&id=1157cc50&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1157cc50"]])

export default __exports__